import { CoinType } from '@starsoft/common/models';
import { Tab } from '../../../../Tabs/Tab/props';

export const transactionsTabsOptions: Tab<CoinType>[] = [
  {
    label: 'fiat_label',
    value: CoinType.Fiat,
  },
  {
    label: 'crypto_label',
    value: CoinType.Crypto,
  },
];
